// Created in order to avoid error importing this component directly on cofee script
import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import SvgWarningIcon from 'zignal-landscape/lib/Icon/WarningIcon';

const StaleIcon = ({styles}) => {
  return (
    <span className={styles.StaleIcon}>
      <ToolTip
        tooltipText={<span>This data is outdated. We are<br />currently updating your data.</span>}
      >
        <SvgWarningIcon />
      </ToolTip>
    </span>
  );
};

StaleIcon.propTypes = {
  styles: PropTypes.object.isRequired
};

export default themeable(StaleIcon);
